import React, { useState, useEffect } from "react";

import "../Styles/Components/HomePage.scss";

const ScrollTestimonial = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const testimonials = [
    {
      logo: "..\\assets\\images\\new_index\\testimonials\\beckerlogo.svg",
      text: "Nxatel seamlessly integrated with our Yealink Teams phones via SIP trunking through MS Teams, ensuring efficient and reliable communication between our warehousing, front office, and customers. This has significantly enhanced our productivity and service delivery. Head of Procurement",
      author: "– Beckers South Africa",
    },
    {
      logo: "..\\assets\\images\\new_index\\testimonials\\Mediwell.svg",
      text: "The Nxatel App has transformed our operations with its efficiency and flexibility. By seamlessly integrating our contact centers and back office, it streamlines appointment scheduling and medical advisory services. Its user-friendly design enhances team productivity and elevates client satisfaction. – CEO and Founder",
      author: "- MediWell",
    },
    {
      logo: "..\\assets\\images\\new_index\\testimonials\\spar.svg",
      text: "The Nxatel App has been a game-changer for Spar Supermarket, streamlining communication between departments and driving operational efficiency. It enhances collaboration, simplifies tasks, and ensures smooth service delivery for both staff and customers. Managing Director and Owner",
      author: "– Spar Supermarket",
    },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % testimonials.length);
    }, 10000); // Auto-scroll every 10 seconds

    return () => clearInterval(interval);
  }, []);

  const currentTestimonial = testimonials[currentIndex];

  return (
    <section className="scroll-testimonial">
      <div className="scroll-testimonial__container">
        <div className="scroll-testimonial__logo col-md-3">
          <img src={currentTestimonial.logo} alt="Company Logo" />
        </div>
        <div className="scroll-testimonial__text col-md-9">
          <p style={{ fontSize: "20px" }}>{currentTestimonial.text}</p>
          <span
            className="scroll-testimonial__author"
            style={{ fontSize: "20px" }}
          >
            {currentTestimonial.author}
          </span>
        </div>
      </div>
    </section>
  );
};

export default ScrollTestimonial;
